import React, { useEffect, useState, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Register from './pages/Register'; // Make sure this path is correct
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import './App.css'; // Ensure you have your main CSS file

const PageFallback = () => <div className="app-page-loading">Loading…</div>;

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Approvals = lazy(() => import('./pages/Approvals'));
const Reports = lazy(() => import('./pages/Reports'));
const AttendanceReport = lazy(() => import('./pages/AttendanceReport'));
const Network = lazy(() => import('./pages/Network'));
const Onboarding = lazy(() => import('./pages/Onboarding'));
const Profile = lazy(() => import('./pages/Profile'));
const LiveTracking = lazy(() => import('./pages/LiveTracking'));
const Notifications = lazy(() => import('./pages/Notifications'));
const Compliance = lazy(() => import('./pages/Compliance'));
const Inventory = lazy(() => import('./pages/Inventory'));
const Leaderboard = lazy(() => import('./pages/Leaderboard'));

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      {user ? (
        <div className="flex">
          <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
          <div className="app-container flex-grow">
            <Navbar onMenuClick={() => setSidebarOpen(true)} />
            <Suspense fallback={<PageFallback />}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/approvals" element={<Approvals />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/inventory" element={<Inventory />} />
                <Route path="/leaderboard" element={<Leaderboard />} />
                <Route path="/attendance-report" element={<AttendanceReport />} />
                <Route path="/network" element={<Network />} />
                <Route path="/onboarding" element={<Onboarding />} />
                <Route path="/live-tracking" element={<LiveTracking />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/compliance" element={<Compliance />} />
                <Route path="/profile" element={<Profile />} />
              </Routes>
            </Suspense>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Login />} /> {/* Redirect unknown routes to login */}
        </Routes>
      )}
    </Router>
  );
}

export default App;
